import { z } from 'zod';
import { TimestampSchema, UuidSchema } from './primitives';

/** `memberships` row — user ↔ tenant join with an assigned role. */
export const MembershipSchema = z.object({
  id: UuidSchema,
  user_id: UuidSchema,
  tenant_id: UuidSchema,
  role_id: UuidSchema,
  joined_at: TimestampSchema,
});
export type Membership = z.infer<typeof MembershipSchema>;

/**
 * `roles` row. System roles (is_system=true) are tenant-agnostic and have
 * tenant_id=null; tenant-owned custom roles carry a tenant_id.
 */
export const RoleSchema = z.object({
  id: UuidSchema,
  tenant_id: UuidSchema.nullable(),
  name: z.string().min(1).max(80),
  scopes: z.array(z.string().min(1)),
  is_system: z.boolean(),
  created_at: TimestampSchema,
});
export type Role = z.infer<typeof RoleSchema>;
